import React from 'react';
import { Link } from 'react-router-dom';
// Assets
import Icon from 'assets/Icon';
// Style
import styles from './style/drawerLink.module.css';

interface DrawerLinkProps {
  active?: boolean,
  handler?: Function,
  href?: string,
  icon: string,
  iconBackground?: string,
  iconFill?: string,
  label?: string,
}

const DrawerLink = ({
  active,
  handler,
  href,
  icon,
  iconBackground,
  iconFill,
  label,
}: DrawerLinkProps) => {
  if (handler) {
    return (
      <button
        className={styles.container}
        onClick={() => handler()}
        type="button"
      >
        <div
          className={`
            ${styles.icon} 
            ${iconBackground ? styles[iconBackground] : ''}
          `}
        >
          { active && (
            <span className={styles.icon__active} />
          )}
          <Icon icon={icon} fill={iconFill || 'white'} size={16} />
        </div>
        <span className="subtitle1">{ label }</span>
      </button>
    );
  }

  if (href) {
    return (
      <Link
        className={styles.container}
        to={href}
      >
        <div
          className={`
            ${styles.icon} 
            ${iconBackground ? styles[iconBackground] : ''}
          `}
        >
          <Icon icon={icon} fill={iconFill} size={16} />
        </div>
        <span className="subtitle1">{ label }</span>
      </Link>
    );
  }

  return (
    <div className={styles.container}>
      <div
        className={`
          ${styles.icon} 
          ${iconBackground ? styles[iconBackground] : ''}
        `}
      >
        <Icon icon={icon} fill={iconFill} size={16} />
      </div>
      <span className="subtitle1">{ label }</span>
    </div>
  );
};

DrawerLink.defaultProps = {
  active: false,
  handler: () => null,
  href: '',
  iconBackground: '',
  iconFill: '',
  label: '',
}

export default DrawerLink;
